import React from 'react';

export interface WebsitePageHeaderProps {
  title: string;
  subtitle?: string;
  intro?: string;
  align?: 'left' | 'center';
  actions?: React.ReactNode;
}

export const WebsitePageHeader: React.FC<WebsitePageHeaderProps> = ({
  title,
  subtitle,
  intro,
  align = 'left',
  actions,
}) => {
  const isCenter = align === 'center';

  return (
    <header
      className={`flex flex-col gap-4 sm:gap-5 ${
        isCenter ? 'items-center text-center' : 'items-start text-left'
      }`}
    >
      <div
        className={`flex gap-4 sm:gap-5 w-full ${
          isCenter ? 'flex-col items-center' : 'flex-row items-start'
        }`}
      >
        {!isCenter && <div className="lp-accent-bar self-stretch min-h-[3rem] hidden sm:block" aria-hidden />}
        <div className={`lp-section-tight flex-1 min-w-0 ${isCenter ? 'items-center' : ''}`}>
          <h1
            className={`lp-heading-display text-3xl sm:text-4xl md:text-5xl lg:text-[clamp(2.5rem,5vw,3.75rem)] ${
              isCenter ? 'mx-auto' : ''
            }`}
          >
            {title}
          </h1>
          {subtitle && (
            <p className={`lp-prose-muted ${isCenter ? 'mx-auto max-w-2xl' : 'max-w-2xl'}`}>
              {subtitle}
            </p>
          )}
          {intro && (
            <p className={`lp-text-secondary max-w-3xl ${isCenter ? 'mx-auto' : ''}`}>
              {intro}
            </p>
          )}
        </div>
      </div>
      {actions && (
        <div className={`flex flex-wrap gap-3 sm:gap-4 ${isCenter ? 'justify-center' : ''}`}>
          {actions}
        </div>
      )}
    </header>
  );
};
